import React, { useEffect, useMemo, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import api from "@/lib/api";

export default function RequireAdmin({ children }) {
  const [state, setState] = useState("loading");
  const location = useLocation();
  const navState = useMemo(() => ({ from: location }), [location]);

  useEffect(() => {
    const token = localStorage.getItem("vault_token");
    if (!token) {
      setState("nope");
      return;
    }
    api
      .get("/auth/me")
      .then(() => setState("ok"))
      .catch(() => setState("nope"));
  }, []);

  if (state === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--vault-bg)" }}>
        <span className="spin" style={{ borderTopColor: "var(--vault-gold)" }} />
      </div>
    );
  }
  if (state === "nope") {
    return <Navigate to="/admin/login" state={navState} replace />;
  }
  return children;
}
